import { create } from 'zustand';
import type { SeoConfigSetting } from '@ecom/contracts';
import { api } from '@/lib/api-client';

/**
 * The store's SEO settings as the storefront reads them (ADR-095) — for the
 * search previews beside every editor. Read from the public settings, so a
 * staff member who may edit a category but not the settings still sees the
 * title its result will really show.
 */
interface SeoConfigState {
  config: Partial<SeoConfigSetting> | null;
  load: (force?: boolean) => Promise<void>;
}

export const useSeoConfigStore = create<SeoConfigState>((set, get) => ({
  config: null,
  async load(force = false) {
    if (get().config && !force) return;
    try {
      const settings = await api.settings.public();
      set({ config: settings['seo.config'] ?? {} });
    } catch {
      // A preview without the store's pattern is still a preview.
      set({ config: {} });
    }
  },
}));
